import { Drawer } from 'vaul'

import { cn } from '~/utils/cn'

type BottomSheetContentProps = React.ComponentPropsWithRef<
  typeof Drawer.Content
> & {
  showOverlay?: boolean
}

function BottomSheetContent({
  children,
  showOverlay = true,
  ...props
}: BottomSheetContentProps) {
  return (
    <Drawer.Portal>
      {showOverlay && (
        <Drawer.Overlay className={cn('fixed inset-0 bg-black/40')} />
      )}

      <Drawer.Content
        {...props}
        className={cn(
          'fixed right-0 bottom-0 left-0 h-fit max-h-screen bg-[var(--color-container-fill-default)]',
          'rounded-tl-[var(--border-radius-mediumcontainer)] rounded-tr-[var(--border-radius-mediumcontainer)]'
        )}
        data-scope="bottom-sheet-content"
      >
        <span
          className={cn(
            'block h-[var(--sizing-nano)] w-[var(--sizing-medium)] rounded-[var(--border-radius-smallcontainer)] bg-[var(--color-fill-neutral-fallback)]',
            '-translate-x-1/2 fixed top-1.5 left-1/2'
          )}
        />

        {children}
      </Drawer.Content>
    </Drawer.Portal>
  )
}

export { BottomSheetContent }
